<template>
    <div class="product">
        <Carousel :list="config.banner.product"/>
        <Title class="title animation" anniset="animated fadeInDown" title="产品展示" description="规模大、实力强、品质保障、技术先进、储量丰富"></Title>
        <div class="main animation" anniset="animated fadeInUp">
            <div class="card sacleBig" v-for="(item,index) in config.product" :key="index">
                <div class="img">
                    <img :src="item.img" class="card-img-top" alt="...">
                </div>
                <div class="card-body">
                    <h5 class="card-title">{{item.name}}</h5>
                    <p class="card-text">{{item.description}}</p>
                    <a  class="btn btn-primary" @click="goRouter(item.id)">了解详情</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Carousel from '@/components/Carousel'
import Title from '@/components/Title'
export default {
    components: {
        Carousel,Title
    },
    data(){
        return {
            config
        }
    },
    methods:{
        goRouter(id){
            this.$router.push(`/detail/${id}`);
        }
    },
    mounted(){
        let documentClientHeight = document.documentElement.clientHeight || window.innerHeight;
        let containers = $('body').find('.animation');
        window.addEventListener("scroll",function(e){
        $.each(containers, function (index, item) {
            var top = item.getBoundingClientRect().top;
            if (documentClientHeight >= top) {
                $(item).addClass($(item).attr('anniset'));
            }
        });
        });
        $.each(containers, function (index, item) {
            let  top = item.getBoundingClientRect().top;
            if (documentClientHeight >= top) {
            $(item).addClass($(item).attr('anniset'));
            }
        });
    }
    
}
</script>
<style lang="less" scoped>
.title{
    padding-top: 30px;
}
    .main{
        display: flex;
        flex-wrap: wrap;
        max-width: 1200px;
        width: 90%;
        margin: 50px auto 0;
        .card{
            flex: 0 0 25%;
            padding: 0 10px;
            margin-bottom: 50px;
            .card-text{
                text-overflow: ellipsis; /*超出部分裁剪，必须*/
                display: -webkit-box; /*必须*/
                -webkit-box-orient: vertical; /*属性规定框的子元素应该被水平或垂直排列。*/                    
                overflow: hidden; /*超出部分隐藏*/
                -webkit-line-clamp: 3; /*在第几行的时候超出部分隐藏*/
                height: 60px;
            }
            .img{
                width:100%;height:0;position: relative;padding-bottom: 100%;
                img{
                width:100%;height:100%;position: absolute;
                }
            }
        }
    }
    @media only screen and (max-width: 1050px){
        .main{
            .card{
                flex: 0 0 calc(100% / 3);
            }
        }
    }
    @media only screen and (max-width: 768px){
        .main{
            .card{
                flex: 0 0 calc(100% / 2);
            }
        }
    }
    @media only screen and (max-width: 520px){
        .main{
            .card{
                flex: 0 0 100%;
            }
        }
    }
</style>